<template>
  <div class="messaging-setting">
    <div class="title-header">
      <p>INTRODUCTIONS</p>
    </div>
    <div class="card">
      <img src="../../assets/images/Dashboard.png" alt="Avatar" style="width: 100%" />
      <div class="container">
        <p><b>The Enwoke Dashboard</b></p>
        <p>See a step-by-step introduction to the elements of the Enwoke Dashboard.</p>
        <button>LAUNCH</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.messaging-setting {
  .title-header {
    color: #58595b;
    font-size: 24px;
    font-weight: 600;
  }
  .card {
  transition: 0.3s;
  width: 24.55%;
  border-radius: 5px;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}

img {
margin-left: auto;
margin-right: auto;
margin-top: 2%;
max-width: 95%;
}

.container {
    font-weight: lighter;
  font-size: 14px;
  button {
      width: 100%;
      height: 36px;
      color: #fff;
      border-radius: 5px;
      background-color: #58595b;
  }
  
}
}
</style>